import { Outlet, useLocation } from 'react-router-dom';
import UserContext, { useUserContext } from '../../contexts/UserContext';
import TopBar from "../TopBar/TopBar";
import Footer from '../Home/Footer/Footer';
import './styles.css';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom'
import LinearLoader from 'components/Loader/LinearLoader';

const UserLayout = () => {
    const location = useLocation();
    const { promo } = useParams();
    
    useEffect(() => window.scrollTo({ top: 0, behavior: 'smooth' }), [location.pathname]);
    
    const contextValue = useUserContext(promo); 
    
    useEffect(() => { 
        if (!contextValue.currentPromo) {
            return;
        }
        import(`../../promos/${contextValue.currentPromo.path}/style.css`).then(() => console.debug('CSS Imported'));
    }, [contextValue.currentPromo])

    return (
        <>
            {contextValue.loading ? <LinearLoader></LinearLoader> :
                <UserContext.Provider value={contextValue}>
                    <div className="background">
                        <TopBar />
                        <Outlet />
                        <Footer />
                    </div>
                </UserContext.Provider>}
        </>
    );
};

export default UserLayout;